import { Alert, Form, Input, Row, Select } from "antd"
import { useState } from "react"
import { SystemDescriptions } from "src/common/descriptions"
import { IncomeRecord } from "src/common/models/incomeRecord"
import { amountValidator, getInputRequiredRule } from "src/common/util"
import { Col12, Col24 } from "src/components/Columns"
import { CurrencyInput } from "src/components/CurrencyInput"
import { FormActionButtons } from "src/components/FormActionButtons"

interface Props {
    initialValues?: IncomeRecord
    onFinish: (incomeRecord: Partial<IncomeRecord>) => void
    onCancel: () => void
}

export const IncomeRecordForm = (props: Props) => {
    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.CREATE_INCOME_RECORD
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const [isLoan, setIsLoan] = useState<boolean>(false);

    const [form] = Form.useForm();

    const onFinish = (formValues) => {
        const expenditureRecord: IncomeRecord = {
            datetime: "",
            description: formValues.description,
            isDeleted: false,
            total: Number(formValues?.total ?? '0'),
            userId: 0,
            isLoan,
        }

        props.onFinish(expenditureRecord)
    }

    const getButtonStatus = (): boolean => {
        return props.initialValues
            ? false
            : !form.isFieldsTouched(true) ||
            form.getFieldsError().filter(({ errors }) => errors.length)
                .length > 0
    }

    const handleCancelClick = () => {
        props.onCancel()
    }

    const renderButtons = () => (
        <FormActionButtons
            cancelText={descriptions.CANCEL_BUTTON}
            actionText={descriptions.SAVE_BUTTON}
            actionDisabled={getButtonStatus}
            onCancel={handleCancelClick}
        />
    )

    const handleIsLoanChange = (e) => {
        setIsLoan(e === "1" ? true : false)
    }

    const renderForm = () => (
        <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]}>
                <Col24>
                    <Form.Item
                        label={descriptions.FORM.DESCRIPTION.LABEL}
                        name={"description"}
                        rules={[
                            getInputRequiredRule(descriptions.FORM.DESCRIPTION.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Input
                            placeholder={descriptions.FORM.DESCRIPTION.PLACEHOLDER}
                            maxLength={45}
                            showCount
                        />
                    </Form.Item>
                </Col24>
                <Col12>
                    <Form.Item
                        label={descriptions.FORM.IS_LOAN.LABEL}
                        name={"isLoan"}
                        rules={[
                            getInputRequiredRule(descriptions.FORM.IS_LOAN.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Select
                            options={[{
                                value: "1",
                                label: commonDescriptions.YES,
                            }, {
                                value: "0",
                                label: commonDescriptions.NO,
                            }]}
                            placeholder={descriptions.FORM.IS_LOAN.PLACEHOLDER}
                            onChange={handleIsLoanChange}
                        />
                    </Form.Item>
                </Col12>
                <Col12>
                    <Form.Item
                        label={descriptions.FORM.TOTAL.LABEL}
                        name={"total"}
                        rules={[
                            getInputRequiredRule(descriptions.FORM.TOTAL.LABEL),
                            {
                                validator: (_, value) => {
                                    return amountValidator(value)
                                }
                            },
                        ]}
                        validateTrigger={["onBlur", "onChange"]}
                    >
                        <CurrencyInput
                            placeholder={descriptions.FORM.TOTAL.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col12>
            </Row>
            {
                isLoan &&
                <Alert
                    message={descriptions.LOAN_WARNING_TITLE}
                    showIcon
                    description={descriptions.LOAN_WARNING}
                    type="warning"
                    style={{
                        marginBottom: 12,
                    }}
                />
            }
            {/* {
                reduxProps.error &&
                <Alert
                    message={"ERROR"}
                    showIcon
                    description={reduxProps.error?.detail.message ?? commonDescriptions.FORM.UNKNOWN_ERROR}
                    type="error"
                    style={{
                        marginBottom: 12,
                    }}
                />
            } */}
            {renderButtons()}
        </Form>
    )
    return (
        renderForm()
    )
}
